import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';

import { useEffect, useMemo } from 'react';

import { bimActKC2VersionOtherGql } from '../../../workOrderVersionQueries';

const requestId = 'bimActKC2VersionOther';

export const useBimVersionActKC2Other = (actKC2VersionOtherId?: number) => {
    const [bimActKC2OtherReset] = useResetStoreData({ requestId });

    const variables = useMemo(() => ({ actKC2VersionOtherId }), [actKC2VersionOtherId]);

    const [bimActKC2OtherData, bimActKC2OtherStatus] = useRequest({
        requestId,
        query: bimActKC2VersionOtherGql,
        variables,
        withEffect: Boolean(actKC2VersionOtherId),
    });

    useEffect(() => {
        bimActKC2OtherReset(null);
    }, [bimActKC2OtherReset]);

    return {
        bimActKC2OtherData,
        bimActKC2OtherStatus,
    };
};
